import React from "react";
import { Link } from "react-router-dom";

/*
 * Resource Navigator — connects people to partner nonprofits that provide
 * things ZelTechnology doesn't (devices, low-cost internet). We provide the
 * guidance layer; these partners provide the hardware.
 */

const partners = [
  {
    name: "Compudopt",
    what: "Free computers for families, tech education for youth, and help finding low-cost internet.",
    url: "https://www.compudopt.org",
    cta: "Find free computer programs →",
    accent: "#12bfbe",
  },
  {
    name: "Human-I-T",
    what: "Low-cost refurbished laptops and tablets, 5G internet from $14.99/mo, and free digital skills courses.",
    url: "https://www.human-i-t.org",
    cta: "Browse low-cost devices →",
    accent: "#9198e5",
  },
  {
    name: "ZelTechnology",
    what: "The guidance layer: free help setting up, securing, and understanding whatever device or connection you get.",
    url: "/membership",
    internal: true,
    cta: "Get free help from us →",
    accent: "#1e3a8a",
  },
];

export function ResourceNavigator({ compact = false }) {
  return (
    <div className={compact ? "" : "mx-4 max-w-6xl mx-auto"}>
      <div className="text-center mb-8">
        <h2 className="text-3xl font-extrabold text-blue-900 mb-2">
          Need a Device or Internet?
        </h2>
        <p className="text-gray-600 max-w-2xl mx-auto">
          We don't give away hardware — but these trusted nonprofits do, at
          low or no cost. And once you have it, we're here to help you use it
          safely.
        </p>
      </div>
      <div className="grid gap-6 md:grid-cols-3">
        {partners.map((p) => {
          const Cta = p.internal ? Link : "a";
          return (
            <div
              key={p.name}
              className="bg-white rounded-2xl p-6 shadow-lg border-t-4 flex flex-col"
              style={{ borderTopColor: p.accent }}
            >
              <h3 className="font-extrabold text-lg text-blue-900 mb-2">
                {p.name}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed flex-1">
                {p.what}
              </p>
              <Cta
                href={p.internal ? undefined : p.url}
                to={p.internal ? p.url : undefined}
                target={p.internal ? undefined : "_blank"}
                rel={p.internal ? undefined : "noopener noreferrer"}
                className="mt-4 font-bold text-sm hover:underline"
                style={{ color: p.accent }}
              >
                {p.cta}
              </Cta>
            </div>
          );
        })}
      </div>
      <p className="text-center text-gray-400 text-xs mt-6">
        ZelTechnology is not affiliated with these organizations — we simply
        point you to reputable programs we've checked out.
      </p>
    </div>
  );
}

export default ResourceNavigator;
